import { useStoreLogger } from '../logger.ts'
import type {
  IAddressBookFindRequest,
  IAddressBookFindListResponse,
  IAddressBookCreateRequest,
  IAddressBookCreateResponse,
  IHostPortalAddressBookCreateRequest,
  IAoeContact
} from '../types/AddressBookTypes'
import {
  FindAddressBook,
  CreateAddressBook,
  CreateHostPortalAddressBook,
  UpdateAddressBook
} from '../api/AddressBook.ts'


export async function AddressBookFind(
  request: IAddressBookFindRequest,
): Promise<IAddressBookFindListResponse> {
  const logger = useStoreLogger()
  logger.debug('AddressBookFind', request)
  const contacts = await FindAddressBook(request)
  return contacts
}

export async function AddressBookCreate(
  request: IAddressBookCreateRequest,
): Promise<IAddressBookCreateResponse> {
  const logger = useStoreLogger()
  logger.debug('AddressBookCreate', request)
  const addressbookID = await CreateAddressBook(request)
  return addressbookID
}

export async function HostPortalAddressBookCreate(
  request: IHostPortalAddressBookCreateRequest,
): Promise<IAddressBookCreateResponse> {
  const logger = useStoreLogger()
  logger.debug('HostPortalAddressBookCreate', request)
  const addressbookID = await CreateHostPortalAddressBook(request)
  return addressbookID
}

export async function AddressBookUpdate(
  request: IAoeContact,
): Promise<IAoeContact> {
  const logger = useStoreLogger()
  logger.debug('AddressBookUpdate', request)
  const addressbookID = await UpdateAddressBook(request)
  return addressbookID
}
